<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="document-translations-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Document Translations · {{ data.caseNumber }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body document-translations-dialog-body">
        <div class="dialog-shell">
          <div *ngIf="isLoading" class="dialog-state dialog-state-loading">
            <div class="state-spinner" aria-hidden="true"></div>
            <div class="state-title">Loading translated documents</div>
            <div class="state-text">Fetching `/api/v2/documents?case_number={{ data.caseNumber }}`.</div>
          </div>

          <div *ngIf="!isLoading && errorMessage" class="dialog-state dialog-state-error">
            <div class="state-title">Could not load documents</div>
            <div class="state-text">{{ errorMessage }}</div>
            <button class="state-action" type="button" (click)="reload()">Try again</button>
          </div>

          <div *ngIf="!isLoading && !errorMessage && documents.length === 0" class="dialog-state dialog-state-empty">
            <div class="state-title">No translated documents yet</div>
            <div class="state-text">
              No documents were returned for case number <strong>{{ data.caseNumber }}</strong>.
            </div>
          </div>

          <div *ngIf="!isLoading && !errorMessage && documents.length > 0" class="dialog-workspace">
            <div class="document-list-panel">
              <div class="document-list-header">
                <div class="document-list-title">Documents</div>
                <div class="document-list-subtitle">{{ documents.length }} items</div>
              </div>
              <div class="document-grid">
                <button
                  *ngFor="let document of documents; trackBy: trackByUuid"
                  type="button"
                  class="document-card"
                  [class.document-card-selected]="selectedDocument?.uuid === document.uuid"
                  (click)="selectDocument(document)">
                  <div class="document-card-top">
                    <div class="document-name">{{ document.original_document_name || 'Unnamed document' }}</div>
                  </div>
                  <div class="document-meta">
                    <div class="meta-row">
                      <span class="meta-label">Uploaded</span>
                      <span class="meta-value">{{ document.uploaded_at ? (document.uploaded_at | date:'d MMM yyyy, HH:mm') : '-' }}</span>
                    </div>
                  </div>
                </button>
              </div>
            </div>

            <div class="selection-panel">
              <div *ngIf="!selectedDocument" class="selection-panel-empty">
                Select a document to view edit jobs and submit a translation.
              </div>

              <ng-container *ngIf="selectedDocument">
                <div class="selection-panel-header">
                  <div>
                    <div class="selection-panel-title">{{ selectedDocument.original_document_name || 'Unnamed document' }}</div>
                  </div>
                  <!--<div class="selection-panel-count">
                    {{ isLoadingEditJobs ? '...' : selectedDocumentEditJobs.length }}
                  </div>-->
                </div>

                <div class="selection-panel-body">
                  <div class="detail-tabs">
                    <button
                      type="button"
                      class="detail-tab"
                      [class.detail-tab-active]="activeDetailTab === 'pii'"
                      (click)="setActiveDetailTab('pii')">
                      PII entities
                    </button>
                    <button
                      type="button"
                      class="detail-tab"
                      [class.detail-tab-active]="activeDetailTab === 'translate'"
                      (click)="setActiveDetailTab('translate')">
                      Translate
                    </button>
                  </div>

                  <div *ngIf="activeDetailTab === 'pii'" class="detail-tab-panel">
                    <div class="pii-section">
                      <div class="pii-section-header">
                        <div class="selection-toolbar-stats">
                          <span class="selection-label">PII entities</span>
                          <span class="selection-value">{{ selectedDocument.pii_entities?.length || 0 }}</span>
                        </div>
                      </div>

                      <div class="pii-controls">
                        <div class="pii-form">
                          <ng-select
                            class="pii-type-select"
                            [items]="piiEntityTypeOptions"
                            bindLabel="label"
                            bindValue="value"
                            [searchable]="false"
                            [clearable]="false"
                            [placeholder]="'PII type'"
                            [ngModel]="piiEntityType"
                            (ngModelChange)="piiEntityType = $event">
                          </ng-select>
                          <input
                            *ngIf="piiEntityType === 'OTHER'"
                            class="pii-input pii-input-custom-type"
                            type="text"
                            placeholder="Custom entity name"
                            [ngModel]="piiCustomEntityType"
                            (ngModelChange)="piiCustomEntityType = $event" />
                          <input
                            class="pii-input pii-input-value"
                            type="text"
                            placeholder="PII value"
                            [ngModel]="piiEntityValue"
                            (ngModelChange)="piiEntityValue = $event" />
                          <button
                            type="button"
                            class="pii-submit"
                            aria-label="Add PII entity"
                            title="Add PII entity"
                            [disabled]="isSavingPiiEntities"
                            (click)="addPiiEntity()">
                            <span
                              class="pii-submit-icon"
                              [class.pii-submit-icon-loading]="isSavingPiiEntities"
                              aria-hidden="true">
                              +
                            </span>
                          </button>
                        </div>

                        <div *ngIf="getVisibleSuggestedPiiEntities().length > 0" class="pii-suggestions">
                          <button
                            *ngFor="let entity of getVisibleSuggestedPiiEntities()"
                            type="button"
                            class="pii-suggestion"
                            [disabled]="isSavingPiiEntities"
                            (click)="addSuggestedPiiEntity(entity)">
                            <span class="pii-suggestion-label">{{ entity.label }}</span>
                            <span class="pii-suggestion-value">{{ entity.value }}</span>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="piiErrorMessage" class="translation-feedback translation-feedback-error">
                        {{ piiErrorMessage }}
                      </div>

                      <div *ngIf="piiSuccessMessage" class="translation-feedback translation-feedback-success">
                        {{ piiSuccessMessage }}
                      </div>

                      <div *ngIf="!selectedDocument.pii_entities || selectedDocument.pii_entities.length === 0" class="pii-empty-state">
                        No PII entities configured for this document.
                      </div>

                      <div *ngIf="selectedDocument.pii_entities && selectedDocument.pii_entities.length > 0" class="pii-list">
                        <div *ngFor="let entity of selectedDocument.pii_entities; trackBy: trackByPiiEntity" class="pii-row">
                          <div class="pii-row-main">
                            <div class="pii-row-type">{{ entity.entity_type || '-' }}</div>
                            <div class="pii-row-value">{{ entity.value || '-' }}</div>
                          </div>
                          <button
                            type="button"
                            class="pii-delete"
                            aria-label="Remove PII entity"
                            title="Remove PII entity"
                            [disabled]="isSavingPiiEntities"
                            (click)="removePiiEntity(entity)">
                            <span class="pii-delete-icon" aria-hidden="true">-</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="activeDetailTab === 'translate'" class="detail-tab-panel">
                    <div class="translation-form">
                      <div class="translation-action-row">
                        <div class="translation-controls">
                          <div class="translation-select-wrap">
                            <label class="translation-select-label">Translate document to</label>
                            <ng-select
                              class="translation-select"
                              [items]="translationLanguages"
                              bindLabel="label"
                              bindValue="value"
                              [searchable]="false"
                              [clearable]="false"
                              [ngModel]="selectedLanguage"
                              (ngModelChange)="selectedLanguage = $event">
                              <ng-template ng-label-tmp let-item="item">
                                <span class="translation-option">
                                  <span *ngIf="item.code" [ngClass]="'fi fi-' + item.code.toLowerCase()"></span>
                                  <span>{{ item.label }}</span>
                                </span>
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item">
                                <span class="translation-option">
                                  <span *ngIf="item.code" [ngClass]="'fi fi-' + item.code.toLowerCase()"></span>
                                  <span>{{ item.label }}</span>
                                </span>
                              </ng-template>
                            </ng-select>
                          </div>

                          <button
                            type="button"
                            class="translation-submit"
                            [disabled]="isSubmittingTranslation"
                            (click)="submitTranslation()">
                            {{ isSubmittingTranslation ? 'Submitting...' : 'Submit' }}
                          </button>
                        </div>
                      </div>

                      <div *ngIf="submitErrorMessage" class="translation-feedback translation-feedback-error">
                        {{ submitErrorMessage }}
                      </div>

                      <div *ngIf="submitSuccessMessage" class="translation-feedback translation-feedback-success">
                        {{ submitSuccessMessage }}
                      </div>
                    </div>

                    <div *ngIf="isLoadingEditJobs" class="detail-panel-state">
                      Loading translations for this document...
                    </div>

                    <div *ngIf="!isLoadingEditJobs && editJobsErrorMessage" class="detail-panel-state selection-panel-error">
                      {{ editJobsErrorMessage }}
                    </div>

                    <ng-container *ngIf="!isLoadingEditJobs && !editJobsErrorMessage">
                      <div class="selection-toolbar">
                        <div class="selection-toolbar-stats">
                          <span class="selection-label">Translations</span>
                          <span class="selection-value">{{ selectedDocumentEditJobs.length }}</span>
                        </div>
                        <button type="button" class="selection-refresh" (click)="refreshSelectedDocumentEditJobs()">
                          Refresh translations
                        </button>
                      </div>

                      <div *ngIf="selectedDocumentEditJobs.length === 0" class="job-empty-state">
                        No translations have been created for this document yet.
                      </div>

                      <div *ngIf="selectedDocumentEditJobs.length > 0" class="job-list">
                        <div *ngFor="let job of selectedDocumentEditJobs" class="job-row">
                          <div class="job-row-main">
                            <div class="job-row-title">
                              <span class="job-row-id">#{{ job.id == null ? '-' : job.id }}</span>
                              <span class="status-badge" [ngClass]="getStatusBadgeClass(job.status)">
                                <span class="status-icon">{{ getStatusIcon(job.status) }}</span>
                                <span>{{ job.status || '-' }}</span>
                              </span>
                            </div>
                            <div class="job-row-meta">
                              <span class="job-row-language" *ngIf="getTranslationLanguage(job) !== '-'">
                                <span *ngIf="getTranslationLanguageFlag(job)" [ngClass]="'fi fi-' + getTranslationLanguageFlag(job)"></span>
                                <span>{{ getTranslationLanguage(job) }}</span>
                              </span>
                              <span class="job-row-date">{{ job.created_at ? (job.created_at | date:'d MMM yyyy, HH:mm') : '-' }}</span>
                              <span class="job-row-duration" *ngIf="getTranslationDuration(job) as translationDuration">
                                {{ translationDuration }}
                              </span>
                            </div>
                          </div>
                          <div class="job-actions">
                            <button
                              type="button"
                              class="job-text-view"
                              aria-label="Open translated text"
                              title="Open translated text"
                              [disabled]="job.id == null || job.status !== 'DONE' || openingTextJobId === job.id"
                              (click)="openTranslatedText(job)">
                              <span
                                class="job-text-view-icon"
                                [class.job-text-view-icon-loading]="openingTextJobId === job.id"
                                aria-hidden="true">
                                T
                              </span>
                            </button>
                            <button
                              type="button"
                              class="job-download"
                              aria-label="Download translated document"
                              title="Download translated document"
                              [disabled]="job.id == null || job.status !== 'DONE' || downloadingJobId === job.id"
                              (click)="downloadTranslatedDocument(job)">
                              <span
                                class="job-download-icon"
                                [class.job-download-icon-loading]="downloadingJobId === job.id"
                                aria-hidden="true">
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
